module.exports = __webpack_public_path__ + "static/GriegMinuttForMinutt.99794b9b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/posts/img/GriegMinuttForMinutt.jpg
// module id = 51
// module chunks = 60070788768415 213130420965792 213534597649335